import { ProductTransformationComponent } from "@products/product-transformation/product-transformation.component";
import { ProductBlendsComponent } from "@products/product-blends/product-blends.component";
import { AssessmentComponent } from "@app/fleet/assessment/assessment.component";
import { ManageImagesComponent } from "@app/fleet/manage-images/manage-images.component";
import { PrintTemplatesComponent } from "@app/settings/print-templates/print-templates.component";
import { TaxRatesComponent } from "@app/settings/tax-rates/tax-rates.component";
import { PrintTextsComponent } from "@settings/print-text/print-text.component";
import { ServerConfigurationComponent } from "@settings/server-configuration/server-configuration.component";
import { ModulesComponent } from "@settings/modules/modules.component";
import { DriverManagementComponent } from "@app/fleet/driver-management/driver-management.component";
import { LoginComponent } from "@app/login/login.component"
import { TimeLogComponent } from "@app/fleet/time-log/time-log.component";
import { FleetManagementComponent } from "@app/settings/fleet-management/fleet-management.component";
import { ExportConfigurationComponent } from "@app/fleet/export-configuration/export-configuration.component";

import last from 'lodash/last';

import {} from './../overrides'

import * as bootstrap from "bootstrap";
import { RequiredValidator } from "@angular/forms";
import { downgradeComponent } from "@angular/upgrade/static";
import { HeaderComponent } from "@app/header/header.component";
import { FooterComponent } from "@app/footer/footer.component";
import { HomeComponent } from "@app/home/home.component";
import { LoginSSOComponent } from "@app/login-sso/login-sso.component";
import { ProductComponent } from "@products/product/product.component";
import { UsersComponent } from "@settings/users/users.component";
import { AdditionalFieldsComponent } from "@app/fleet/additional-fields/additional-fields.component";
import { LoadPointComponent } from "@app/load-point/load-point.component";
import { ConfigurationGroupComponent } from '@app/fleet/configuration-group/configuration-group.component';
import { CustomerComponent } from "@app/customers/customer/customer.component";
import { VehicleComponent } from '@app/fleet/vehicle/vehicle.component';
import { DataAreaComponent } from "@products/data-area/data-area.component";
import { AuditLogComponent } from "@settings/audit-log/audit-log.component";
import { CompanyComponent } from "@settings/company/company.component";
import { DeviceMappingComponent } from "@products/device-mapping/device-mapping.component";
import { CustomerDataAreaComponent } from "@app/customers/customer-data-area/customer-data-area.component";
import { TranspacConfigurationComponent } from "@fleet/transpac-configuration/transpac-configuration.component";
import { StrappingChartComponent } from "@app/customers/strapping-chart/strapping-chart.component";
import { DeviceGroupComponent } from "@products/device-group/device-group.component";
import { PaymentTermComponent } from "@settings/payment-term/payment-term.component";
import { BankAccountComponent } from "@settings/bank-account/bank-account.component";
import { SafetyCheckComponent } from "@app/safety-check/safety-check.component";
import { FactorComponent } from "@products/factor/factor.component";
import { ProductGroupComponent } from "@products/product-group/product-group.component"
import { PriceGroupComponent } from "@products/price-group/price-group.component";
import { ImportConfigurationComponent } from "@fleet/import-configuration/import-configuration.component";
var app = angular.module('FleetAtlasApp', ['ui.router', 'ui.router.upgrade', 'ui.bootstrap', 'angulartics', 'angulartics.google.analytics', 'dx', 'ui.sortable', 'ui.select', 'colorpicker.module', 'ngFileUpload']);

app.directive('facnmHeader', downgradeComponent({component: HeaderComponent}));
app.directive('facnmFooter', downgradeComponent({component: FooterComponent}));
app.run(['$rootScope', '$window', '$document', '$trace', '$transitions', '$templateCache', function ($rootScope, $window, $document, $trace, $transitions, $templateCache) {

    $trace.enable('TRANSITION');

    $rootScope.fixGridSearchBackspace = [];

    $transitions.onFinish({}, function (transition) {

        try {
            $rootScope.fixGridSearchBackspace.forEach(element => {
                $document.context.removeEventListener("keyup", element);
            });

            $rootScope.fixGridSearchBackspace = [];
        }
        catch { }

        if (transition.$to().component) {

            let masterFactory = transition.injector().get('masterFactory');
            masterFactory.verifyAuthentication();
        }
    });


    $rootScope.user = {
        username: '',
        company: '',
        isAuthenticated: false,
        bearerToken: '',
        expirationDate: null
    };

    $rootScope.getLables=function(configId)
    {
        var data = {}
        switch (configId) {
            case 282:
                data= {
                    addModalTitle:"Add New Register",
                    addButtonLabel:"Add Register",
                    listLabel:"Register "
                }
                break;
            case 408:
                data= {
                    addModalTitle:"Emissions Factors",
                    addButtonLabel:"Add Factor Group",
                    listLabel:"Group "
                }
                break;
        
            default:
                data= {
                    addModalTitle:"Add",
                    addButtonLabel:"Add ",
                    listLabel:"List"
                }
                break;
        }
        return data;
    }
    function formatLabel(str)
    {
        return str.replace(/_/g,' ').replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }
    $rootScope.formatLabel = formatLabel;
    
    (function configureMoment() {
        if (!moment)
            return;

        var nav = $window.navigator, i, language;

        var languages = [nav.language]; // supported by most browsers, except ie < 11
        languages = languages.concat(nav.languages); // html 5, only supported by firefox & chrome currently
        languages = languages.concat([nav.userLanguage, nav.browserLanguage, nav.systemLanguage]); // ie <= 10 only
        languages.push('en'); // default

        for (i = 0; i < languages.length; i++) {
            language = languages[i];
            if (language && language.length)
                break;
        }

        // if browser language is british english use australian english instead
        // en-gb shows times in 24 hour format by default - not what you want if you are, for example, in australia but using chrome or firefox with british english language
        language = /en-gb/i.test(language) ? 'en-AU' : language;

        // set moment locale globally
        moment.locale(language);
    })();
    
    $templateCache.put("app-legacy/Entities/templates/modal-scrollable-content.html",
      "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal modal-scrollable-content \"\n" +
      "    uib-modal-animation-class=\"fade\"\n" +
      "    modal-in-class=\"in\"\n" +
      "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
      "    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
      "</div>\n" +
      "");
}]);

app.config(['$stateProvider', '$urlRouterProvider', '$httpProvider', function ($stateProvider, $urlRouterProvider, $httpProvider) {

    // Disable IE request caching
    if (!$httpProvider.defaults.headers.get)
        $httpProvider.defaults.headers.get = {};
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    $httpProvider.defaults.headers.get['Expires'] = -1;

    $urlRouterProvider.otherwise('/logout');

    // Please add new state's in alphabetical order. 
    $stateProvider
        .state('home', {
            url: '/home',
            component:HomeComponent,
        })
        .state('additionalfields', {
            url: '/additionalfields',
            component:AdditionalFieldsComponent
        })        
        .state('auditlog', {
            url: '/auditlog',
            component:AuditLogComponent
        }) 
        .state('bankaccount', {
            url: '/bankaccount',
            component:BankAccountComponent
        })
        .state('company', {
            url: '/company',
            component:CompanyComponent
        })
        .state('configurationgroup', {
            url: '/configurationgroup',
            component:ConfigurationGroupComponent
        })
        .state('customer', {
            url: '/customer',
            component:CustomerComponent
        })
        .state('customerdataarea', {
            url: '/customerdataarea',
            component:CustomerDataAreaComponent
        })
        .state('StrappingChartProfiles', {
            url: '/StrappingChartProfiles',
            component : StrappingChartComponent,
        })
        .state('dataarea', {
            url: '/dataarea',
            component:DataAreaComponent
        })
        .state('devicemapping', {
            url: '/devicemapping',
            component: DeviceMappingComponent
        })      
        .state('Assessment', {
            url: '/Assessment',
            component: AssessmentComponent
        })
        .state('deviceproductgroup', {
            url: '/deviceproductgroup',
            component : DeviceGroupComponent
        })        
        .state('Driver', {
            url: '/Driver',
            component: DriverManagementComponent
        })
        .state('drivermanagement', {
            url: '/drivermanagement',
            templateUrl: 'app-legacy/Entities/Driver.html',
            controller: 'DriverController'
        })
        .state('exportconfigurationset', {
            url: '/exportconfigurationset',
			component: ExportConfigurationComponent
        })
        .state('factor', {
            url: '/factor',
            component:FactorComponent
        })
        .state('fleetmanagement', {
            url: '/fleetmanagement',
            component: FleetManagementComponent
        })
        .state('importconfigurationset', {
            url: '/importconfigurationset',
            component: ImportConfigurationComponent
        })
        .state('loadpoint', {
            url: '/loadpoint',
            component: LoadPointComponent
        })
        .state('login', {
            url: '/login',
            component: LoginComponent
        })
        .state('loginSSO', {
            url: '/loginSSO',
            component: LoginSSOComponent
        })
        .state('logout', {
            url: '/logout',
            templateUrl: 'app-legacy/Entities/Login.html',
            controller: 'LogoutController'
        })
        .state('ManageImages', { 
            url: '/ManageImages',
            component: ManageImagesComponent
        })
        .state('paymentterm', {
            url: '/paymentterm',
           component: PaymentTermComponent
        })
        .state('pricegroup', {
            url: '/pricegroup',
            component: PriceGroupComponent
        })
        .state('PrintTemplates', {
            url: '/PrintTemplates',
            component: PrintTemplatesComponent
        })
        .state('PrintTexts', {
            url: '/PrintTexts',
            component: PrintTextsComponent
        })
        .state('product', {
            url: '/product',
            component: ProductComponent
        })
        .state('productgroup', {
            url: '/productgroup',
            component: ProductGroupComponent
        })
        .state('ProductTransformation', {
            url: '/ProductTransformation',
            component: ProductTransformationComponent
        })
        .state('ProductBlends', {
            url: '/ProductBlends',
            component: ProductBlendsComponent
        })
        .state('safetychecktext', {
            url: '/safetychecktext',
            component: SafetyCheckComponent
        })
        .state('ServerConfiguration', {
            url: '/ServerConfiguration',
            component: ServerConfigurationComponent
        })
        .state('TaxRates', {
            url: '/TaxRates',
            component: TaxRatesComponent
        })
        .state('transpacconfiguration', {
            url: '/transpacconfiguration',
            component: TranspacConfigurationComponent
        })
        .state('timelogdefinitions', {
            url: '/timelogdefinitions',
            component:TimeLogComponent
        })
        .state('users', {
            url: '/users',
            component: UsersComponent,
            resolve: {
                isAdmin: function ($rootScope, $q) {
                    var isAdminDefer = $q.defer();
                    if ($rootScope.user.isAdmin) {
                        isAdminDefer.resolve();
                    } else {
                        isAdminDefer.reject();
                    }
                    return isAdminDefer.promise;
                }
            }
        })
        .state('vehicle', {
            url: '/vehicle',
            component: VehicleComponent,
        })
        .state('modules', {
            url: '/modules',
            component: ModulesComponent,
            resolve: {
                isSysAdmin: function ($rootScope, $q) {
                    var isSysAdminDefer = $q.defer();
                    if ($rootScope.user.isSysAdmin) {
                        isSysAdminDefer.resolve();
                    } else {
                        isSysAdminDefer.reject();
                    }
                    return isSysAdminDefer.promise; 
                }
            }
        });
}]);

// Creating directive for focus on an element
app.directive('focusOn', function () {
    return function (scope, elem, attr) {
        scope.$on('focusOn', function (e, name) {
            if (name === attr.focusOn) {
                elem[0].focus();
            }
        });
    };
});

app.directive('fixGridSearchBackspace', function ($document, $rootScope) {

    return {

        restrict: "A",

        link: function ($scope, element, attrs) {

            let _handler = function (event, attrs) {

                let target: any = event.target;
                
                if (attrs.class == 'gridDiv' && (event.code == 'Backspace' || event.code === "Delete") && target.className == 'dx-texteditor-input') {

                    try {
                        let columnName = target.parentElement.parentElement.parentElement.parentElement.parentElement.classList.item(0);

                        if (columnName) {
                            let dataGrid = $('#' + attrs.id).dxDataGrid('instance');
                            dataGrid.columnOption(columnName, "filterValue", target.value);
                        }
                    }
                    catch { }
                }
            }

            $rootScope.fixGridSearchBackspace.push(function _listener(ev) { _handler(ev, attrs); });
            $document.context.addEventListener("keyup", last($rootScope.fixGridSearchBackspace));
        }
    }
});


app.factory('masterFactory', ['$http', '$state', '$rootScope', '$timeout', 'settings', 'version', function ($http, $state, $rootScope, $timeout, settings, version) {
    var masterFunctions =
    {
        setFocus: function (name) {
            $timeout(function () {
                $rootScope.$broadcast('focusOn', name);
            });
        },
        setError: function (status, error, scope) {
            $('#loadingModal').modal('hide');
            if (status == 401 || (status == 500 && angular.isString(error) && error.indexOf('controller') > 0)) {
                $state.go('login');
            }
            else if (status == 403) { //forbidden
                $state.go('home');
            }
            else {
                if (error != null && error.ModelState != null) {
                    for (var key in error.ModelState) {
                        for (var i = 0; i < error.ModelState[key].length; i++) {
                            scope.modelState.push(error.ModelState[key][i]);
                        }
                    }
                }
                else if (angular.isString(error) && error.indexOf("Validation Error:") != -1)
                    scope.modelState.push(error.substring(17, error.length));
                else scope.error = error;
            }
        },
        getCountryList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/countries/0");
        },
        getCustomerTypeList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/customertypes/0");
        },
        getCompanies: function (lookup) {
            var url = settings.ApiURL + settings.CompanyURL;
            return $http.get(url + "/dropdown/" + lookup);
        },
        getUserLoginInfo: function () {
            $http.get(settings.ApiURL + settings.MasterDataURL + "/user-login-info").success(function (userinfo) {
                $rootScope.user.username = userinfo.Username;
                $rootScope.user.company = userinfo.Company;
                $rootScope.user.isAdmin = userinfo.IsAdmin;
                $rootScope.user.isSysAdmin = userinfo.IsSysAdmin;
            }).error(function () {
                $rootScope.user.username = "";
                $rootScope.user.company = "";
                $rootScope.user.isAdmin = false;
                $rootScope.user.isSysAdmin = false;
            });
        },
        getModulesStatus: function(){
            $http.get(settings.ApiURL + settings.ModulesURL + "/status").success(function(modulesstatus){
                $rootScope.user.isStrappingChartEnabled = modulesstatus.IsStrappingChartEnabled;
            }).error(function(){
                $rootScope.user.isStrappingChartEnabled = false;
            });
        },
        verifyAuthentication: function () {
            var bearerToken = sessionStorage.getItem("Bearer");
            var ssoToken = sessionStorage.getItem("SSOToken");
            if ($http.defaults.headers.common.Authorization == null || bearerToken == null) {
                if (bearerToken != null) {
                    $http.defaults.headers.common.Authorization = 'Bearer ' + bearerToken;
                    $rootScope.user.isAuthenticated = true;
                    masterFunctions.getUserLoginInfo();
                    // masterFunctions.RefreshDbIcon();
                    masterFunctions.getModulesStatus();
                }
                else {
                    if($state.router.urlRouter.location != '/loginSSO' && ssoToken == null){
                        $state.go('login');
                    }
                }
            }
        },
        RefreshDbIcon: function () {
            $http.get(settings.ApiURL + settings.LoginURL + "/apiversion/").success(function (data) {
                $rootScope.ApiFileVersion = 'API v.' + data.ApiFileVersion;
                $rootScope.ApiFileInfoVersion = data.ApiFileInfoVersion;
                $rootScope.DbVersion = data.DbVersion;
                $rootScope.RequiredDbVersion = data.RequiredDbVersion;
            }).error(function (data) {
                $rootScope.ApiFileVersion = "no API connecton";
                $rootScope.ApiFileInfoVersion = "";
                $rootScope.DbVersion = 0;
            });
        }
    };
    return masterFunctions;
}]);

// Functions to toggle colors between view details and create new entity
export function ToggleGreenToYellow() {
    $('.collapsible-header-icon').each(function () {
        if ($(this).hasClass("collapsible-header-icon-green-up")) {
            $(this).removeClass("collapsible-header-icon-green-up").addClass("collapsible-header-icon-yellow-up");
        }
        else if ($(this).hasClass("collapsible-header-icon-green-down")) {
            $(this).removeClass("collapsible-header-icon-green-down").addClass("collapsible-header-icon-yellow-down");
        }
    });

    $('.collapsible-header-left').removeClass("collapsible-header-green").addClass("collapsible-header-yellow");
    $('.collapsible-header-right').removeClass("collapsible-header-green").addClass("collapsible-header-yellow");
    $('.collapsible-header-content').removeClass("collapsible-header-content-green").addClass("collapsible-header-content-yellow");

    $('.edit-button').removeClass("edit-button-green").addClass("edit-button-yellow");
    $('.edit-button-image').removeClass("edit-button-image-green").addClass("edit-button-image-yellow");

    $('.editGridDiv').removeClass("editGridDiv").addClass("newGridDiv");
};

export function ToggleYellowToGreen() {
    $('.collapsible-header-icon').each(function () {
        if ($(this).hasClass("collapsible-header-icon-yellow-up")) {
            $(this).removeClass("collapsible-header-icon-yellow-up").addClass("collapsible-header-icon-green-up");
        }
        else if ($(this).hasClass("collapsible-header-icon-yellow-down")) {
            $(this).removeClass("collapsible-header-icon-yellow-down").addClass("collapsible-header-icon-green-down");
        }
    });

    $('.collapsible-header-left').removeClass("collapsible-header-yellow").addClass("collapsible-header-green");
    $('.collapsible-header-right').removeClass("collapsible-header-yellow").addClass("collapsible-header-green");
    $('.collapsible-header-content').removeClass("collapsible-header-content-yellow").addClass("collapsible-header-content-green");

    $('.edit-button').removeClass("edit-button-yellow").addClass("edit-button-green");
    $('.edit-button-image').removeClass("edit-button-image-yellow").addClass("edit-button-image-green");

    $('.newGridDiv').removeClass("newGridDiv").addClass("editGridDiv");
};

//Window resize event
export function onWindowResize(grdName, heightToAdjust) {
    var width = $(window).width();
    var grd = ($(grdName)).dxDataGrid('instance');
    if (grd != null) {
        grd.columnOption(4, 'visible', width > 1000);
        grd.columnOption(3, 'visible', width > 900);
        grd.columnOption(2, 'visible', width > 800);
        grd.option('height', document.documentElement.clientHeight - heightToAdjust);
    }
};

// Grid Selection column width need to be reset on grid content ready
export function resetSelectionColumn(e) {
    var newColWidth = 20;
    setTimeout(function () {
        var headerGrid = e.element.find('.dx-datagrid-headers-container .dx-datagrid-table');
        var headerColgroup = headerGrid.find('colgroup');
        $(headerColgroup.children().get(0)).width(newColWidth);

        var contentGrid = e.element.find('.dx-datagrid-rowsview .dx-datagrid-table');
        var contentColgroup = contentGrid.find('colgroup');

        $(contentColgroup.children().get(0)).width(newColWidth);
    }, 100);
};

// Line toggle event
export function collapsibleHeaderClickEvent($rootScope) {
    $(".collapsible-header-container").click(function () {
        if ($rootScope.pageTitle.indexOf("Edit") >= 0 || $rootScope.pageTitle.indexOf("New") >= 0) {
            $(this).find('.collapsible-header-icon').toggleClass("collapsible-header-icon-yellow-up collapsible-header-icon-yellow-down");
        }
        else {
            $(this).find('.collapsible-header-icon').toggleClass("collapsible-header-icon-green-up collapsible-header-icon-green-down");
        }
    });
};

export function IsUndefinedOrNull(val) {
    return angular.isUndefined(val) || val === null;
};


export default angular.module('FleetAtlasApp');
